import { render, staticRenderFns } from "./MyUpdates.vue?vue&type=template&id=790be12c&scoped=true"
import script from "./MyUpdates.vue?vue&type=script&lang=js"
export * from "./MyUpdates.vue?vue&type=script&lang=js"
import style0 from "./MyUpdates.vue?vue&type=style&index=0&id=790be12c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "790be12c",
  null
  
)

export default component.exports